import React, { useContext } from "react";

import { useSelector } from "react-redux";

import AcertosPorHabilidadePainel from "./Painel";
import LoadingStatistics from "../../LoadingStatistics";
import StatisticFiltersCompare from "../../StatisticFiltersCompare";
import { DataContext } from "../Context/DataContext";

export default function AcertosPorHabilidade({ activity_id: activityId }) {
  const token = useSelector(state => state.user.token);
  const { correctsByAbility, loading, fetchData } = useContext(DataContext);
  const [data, setData] = correctsByAbility;

  const changeFilter = selected => {
    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      school_id: selected.schoolId,
      room_id: selected.roomId,
      activity_id: activityId,
      type: "ability"
    };

    fetchData(params, token, "statistics/evaluation_corrects", setData);
  };

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div className="layoutTabelaComparacao flex-column w-100">
        <StatisticFiltersCompare
          activityId={activityId}
          onChange={changeFilter}
          hideUser
        />
      </div>
      <div className="w-100">
        {loading ? (
          <LoadingStatistics />
        ) : (
          <AcertosPorHabilidadePainel data={data} />
        )}
      </div>
    </div>
  );
}
